import { JobStatus } from '../../@types/Jobs';
export const statusFormat = (status: keyof typeof JobStatus | undefined) => {
  if (status) return `${JobStatus[status]}`;
};
